import React from "react";
import "../tutorRegistration/TutorRegistration.css";

const Step5 = ({ formData, handleInputChange }) => {
  return (
    <>
      <div className="form-title">
        <h2>Almost there! Introduce Yourself!😃</h2>
        <p className="subtitle">
          Tell us more about yourself and connect your social media profiles!
        </p>
      </div>
      <div className="form-group">
        <label>About Yourself</label>
        <textarea
          name="about"
          placeholder="Tell us about your teaching experience, specialties, and what makes you unique..."
          value={formData.about}
          onChange={handleInputChange}
          className="tutor-textarea"
          rows="5"
        />
        <p className="tooltip">
          Share your teaching philosophy, experience, and what students can
          expect from you.
        </p>
      </div>

      <div className="subheading">
        <h3>Add Social Media Account (Optional)</h3>
      </div>

      <div className="form-group">
        <label>LinkedIn URL</label>
        <div className="url-input-container">
          <span className="url-prefix">https://</span>
          <input
            type="text"
            name="linkedinUrl"
            placeholder="www.linkedin.com/in/yourprofile"
            value={formData.linkedinUrl}
            onChange={handleInputChange}
            className="url-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label>Facebook URL</label>
        <div className="url-input-container">
          <span className="url-prefix">https://</span>
          <input
            type="text"
            name="facebookUrl"
            placeholder="www.facebook.com/yourProfile"
            value={formData.facebookUrl}
            onChange={handleInputChange}
            className="url-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label>Instagram URL</label>
        <div className="url-input-container">
          <span className="url-prefix">https://</span>
          <input
            type="text"
            name="instagramUrl"
            placeholder="www.instagram.com/yourProfile"
            value={formData.instagramUrl}
            onChange={handleInputChange}
            className="url-input"
          />
        </div>
      </div>

      <div className="form-group">
        <label>X URL</label>
        <div className="url-input-container">
          <span className="url-prefix">https://</span>
          <input
            type="text"
            name="xUrl"
            placeholder="www.x.com/yourprofile"
            value={formData.xUrl}
            onChange={handleInputChange}
            className="url-input"
          />
        </div>
      </div>
      <div className="form-group">
        <label>Tiktok URL</label>
        <div className="url-input-container">
          <span className="url-prefix">https://</span>
          <input
            type="text"
            name="tiktokUrl"
            placeholder="www.tiktok.com/yourprofile"
            value={formData.tiktokUrl}
            onChange={handleInputChange}
            className="url-input"
          />
        </div>
      </div>
    </>
  );
};

export default Step5;
